export type { TranslationDefinition, RichTextFormatter } from '@manomano-internal/i18n';
export { MessageFormatter } from '@manomano-internal/i18n/esm/MessageFormatter';
export { translate, translateFormatter } from '@manomano-internal/i18n/esm/placeholders';
export type MessageFormatterReturnType<Output = Exclude<React.ReactNode, null | undefined>> = string | Output | (string | Output)[];